import { Component } from '@angular/core';
import { register } from 'swiper/element/bundle';
register();

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent {

  public appPages = [
    {
      title: 'INICIO',
      url: 'app/home',
      icon: 'home'
    },
    {
      title: 'VENTAS',
      url: 'app/ventas',
      icon: 'ventas'
    },
    {
      title: 'SOLICITUDES',
      url: 'app/solicitudes',
      icon: 'solicitudes'
    },
    {
      title: 'REPORTES',
      url: 'app/reportes',
      icon: 'reportes'
    },
    {
      title: 'CONSULTAR ARTÍCULO',
      url: 'app/consultar',
      icon: 'consultar'
    },
    {
      title: 'PERFIL',
      url: 'app/perfil',
      icon: 'perfil'
    }

  ];

  constructor() {}
}
